<template>
  <v-card>
    <!-- <v-card-title>User Login</v-card-title> -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>search</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Advance Search</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="addLoanForm" v-model="valid" lazy-validation>
        <v-layout column>
          <v-flex md3 class="pl-1" v-if="isShow('date')">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="rfilters.date"
                  label="Date From"
                  readonly
                  outline
                  required
                  :rules="requiredRules"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="rfilters.date"
                @input="dateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md3 class="pl-1" v-if="isShow('date2')">
            <v-menu
              v-model="date2Menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="rfilters.date2"
                  label="Date To"
                  readonly
                  outline
                  required
                  :rules="requiredRules"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :min="rfilters.date"
                v-model="rfilters.date2"
                @input="date2Menu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex md6 class="pb-2" v-if="isShow('account_head')">
            <v-autocomplete
              v-model="rfilters.account_head_id"
              :items="accountHeads"
              :loading="isAccountHeadsLoading"
              clearable
              hide-details
              hide-selected
              item-text="title"
              item-value="id"
              label="Search Account Head"
              outline
              @change="onChangeAccountHeadSelect"
            >
              <template v-slot:no-data>
                <v-list-tile>
                  <v-list-tile-title>
                    Search for your required
                    <strong>Account Head</strong>
                  </v-list-tile-title>
                </v-list-tile>
              </template>
            </v-autocomplete>
          </v-flex>

          <v-flex md6 class="pb-2" v-if="isShow('company')">
            <v-autocomplete
              v-model="rfilters.company_id"
              :items="companies"
              :loading="isCompaniesLoading"
              clearable
              hide-details
              hide-selected
              item-text="name"
              item-value="id"
              label="Search Company"
              outline
            >
            </v-autocomplete>
          </v-flex>

          <v-flex md6 class="pb-2" v-if="isShow('client')">
            <v-autocomplete
              v-model="rfilters.client_id"
              :items="clients"
              :loading="isClientsLoading"
              clearable
              hide-details
              hide-selected
              item-text="name"
              item-value="id"
              label="Search Client"
              outline
            >
            </v-autocomplete>
          </v-flex>

          <v-flex md6 class="pb-2" v-if="isShow('coordinator')">
            <v-autocomplete
              v-model="rfilters.coordinator_id"
              :items="coordinators"
              :loading="isCoordinatorsLoading"
              clearable
              hide-details
              hide-selected
              item-text="name"
              item-value="id"
              label="Search coordinator"
              outline
            >
            </v-autocomplete>
          </v-flex>

          
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <!-- <v-btn @click="onApply">Apply</v-btn> -->
      <v-btn @click="onCancelled">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["rfilters", "hide"],
  data() {
    return {
      dateMenu: false,
      date2Menu: false,
      reportFilters: {
        // date: new Date().toISOString().substr(0, 10),
        // date2: new Date().toISOString().substr(0, 10),
      },

      actionButtonClicked: false,
      valid: true,

      isAddFormModal: false,
      isEditFormModal: false,
      editItem: {},

      fromDateMenu: false,

      isDepartmentLoading: false,
      departments: [],
      departmentSearchKey: null,

      moneyAccounts: [],
      isMoneyAccountLoading: false,
      moneyAccountSearchKey: null,

      isAccountHeadsLoading: false,
      accountHeads: [],
      accountHeadSearchKey: null,

      isAgentsLoading: false,
      agents: [],
      agentSearchKey: null,

      loanOutSwitch: false,
      isMALoading: false,

      contactSearch: "",
      contacts: [],
      isContactLoading: false,

      isBillTypesLoading: false,
      billTypes: [],
      billTypeSearch: null,

      isCompaniesLoading: false,
      companies: [],

      isCoordinatorsLoading: false,
      coordinators: [],

      isClientsLoading: false,
      clients: [],
    };
  },
  computed: {
  },
  methods: {
    isShow(filterName) {
      return this.hide && this.hide.includes(filterName) ? false : true;
    },
    onApply() {
      this.$emit("applySearch");
    },
    onCancelled() {
      this.$emit("cancelled");
    },
    onrfiltersAdded() {
      this.$emit("added");
      this.clearForm();
      this.onCancelled();
    },
    validate() {
      if (this.$refs.addLoanForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.addLoanForm.reset();
    },
    resetValidation() {
      this.$refs.addLoanForm.resetValidation();
    },
    clearForm() {},
    // newItemDo() {
    //   if (this.$refs.addLoanForm.validate()) {
    //     this.actionButtonClicked = true;
    //     this.post("/payments", this.newItem).then((res) => {
    //       if (res.data.success) {
    //         this.onNewItemAdded();
    //       }
    //       this.snackbarShow(res.data);
    //       this.actionButtonClicked = false;
    //     });
    //   }
    // },
    // onChangeMoneyAccountSelect(selectedmoneyAccountID) {
    //   const ma = this.moneyAccounts.find(
    //     (item) => item.id == selectedmoneyAccountID
    //   );
    //   this.rfilters.money_account_title = ma ? ma.title : "";
    // },

    loadAccountHeads(val) {
      this.isAccountHeadsLoading = true;
      const getApiaParams = {
        fields: "id,title",
      };

      this.get("/account_heads", getApiaParams).then((response) => {
        this.accountHeads = response.data.data.items;
        this.isAccountHeadsLoading = false;
      });
    },

    loadCompanies(val) {
      this.isCompaniesLoading = true;
      const getApiaParams = {
        fields: "id,name",
      };

      this.get("/companies", getApiaParams).then((response) => {
        this.companies = response.data.data.items;
        this.isCompaniesLoading = false;
      });
    },

    loadClients(val) {
      this.isClientsLoading = true;
      const getApiaParams = {
        fields: "id,name",
      };

      this.get("/clients", getApiaParams).then((response) => {
        this.clients = response.data.data.items;
        this.isClientsLoading = false;
      });
    },

    loadCoordinators(val) {
      this.isCoordinatorsLoading = true;
      const getApiaParams = {
        fields: "id,name",
      };

      this.get("/coordinators", getApiaParams).then((response) => {
        this.coordinators = response.data.data.items;
        this.isCoordinatorsLoading = false;
      });
    },

    // loadAgents(val) {
    //   this.isAgentsLoading = true;
    //   const getApiaParams = {
    //     fields: "id,name",
    //   };

    //   this.get("/agents", getApiaParams).then((response) => {
    //     this.agents = response.data.data.items;
    //     this.isAgentsLoading = false;
    //   });
    // },

    // loadMoneyAccounts() {
    //   this.isMALoading = true;
    //   const getApiaParams = {
    //     fields: "id,title",
    //   };

    //   this.get("/money_accounts", getApiaParams).then((response) => {
    //     this.moneyAccounts = response.data.data.items;
    //     this.isMALoading = false;
    //   });
    // },

    // loadDepartments() {
    //   this.isDepartmentLoading = true;
    //   const getApiaParams = {
    //     fields: "id,title",
    //   };

    //   this.get("/departments", getApiaParams).then((response) => {
    //     this.departments = response.data.data.items;
    //     this.isDepartmentLoading = false;
    //   });
    // },

    // loadBilltypes() {
    //   this.isBillTypesLoading = true;
    //   const getApiaParams = {
    //     fields: "id,title",
    //   };

    //   this.get("/bill_types", getApiaParams).then((response) => {
    //     this.billTypes = response.data.data.items;
    //     this.isBillTypesLoading = false;
    //   });
    // },

    // onChangeBillTypeSelect(selectedBillTypeID) {
    //   const bt = this.billTypes.find((item) => item.id == selectedBillTypeID);
    //   this.rfilters.bill_type_title = bt.title;
    // },

    // onChangeDepartmentSelect(selecteddepartmentID) {
    //   const department = this.departments.find(
    //     (item) => item.id == selecteddepartmentID
    //   );
    //   this.rfilters.department_title = department ? department.title : "";
    // },

    onChangeAccountHeadSelect(selectedAccountHeadID) {
      const accountHead = this.accountHeads.find(
        (item) => item.id == selectedAccountHeadID
      );
      this.rfilters.account_head_title = accountHead ? accountHead.title : "";
    },

    // onChangeAgentSelect(selectedAgentID) {
    //   const agent = this.agents.find(
    //     (item) => item.id == selectedAgentID
    //   );
    //   this.rfilters.agent_id = accountHead ? accountHead.name : "";
    // },

    updateSearchFilterData() {
      this.$emit("input", {
        date: this.reportFilters.date,
        date2: this.reportFilters.date2,
        department_id: this.reportFilters.department_id,
        money_account_id: this.reportFilters.money_account_id,
        account_head_id: this.reportFilters.account_head_id,
      });
    },

    contactsAutoCompleteFilter(item, queryText, itemText) {
      // console.log('Auto complete item: ', item);
      let mobile = "" + item.mobile;
      let email = "" + item.email;
      // console.log('Auto complete mobile: ', mobile);
      return (
        itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1 ||
        mobile.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    onChangeContactSelect(selectedContactID) {
      const contact = this.contacts.find(
        (item) => item.id == selectedContactID
      );
      this.rfilters.contact_name = contact ? contact.name : "";
    },
  },
  mounted() {
    if(this.isShow('account_head'))
      this.loadAccountHeads();
    
    if(this.isShow('company'))
      this.loadCompanies();

    if(this.isShow('agent'))
      this.loadClients();

    if(this.isShow('coordinator'))
      this.loadCoordinators();
  },
  watch: {
    // accountHeadSearchKey(val) {
    //   // Items have already been loaded
    //   if (this.accountHeads.length > 0) return;

    //   this.isAccountHeadsLoading = true;
    //   const getApiaParams = {
    //     fields: "id,title",
    //   };

    //   this.get("/account_heads", getApiaParams).then((response) => {
    //     this.accountHeads = response.data.data.items;
    //     this.isAccountHeadsLoading = false;
    //   });
    // },

    contactSearch(val) {
      // Items have already been loaded
      if (this.contacts.length > 0) return;

      this.isContactLoading = true;
      const getApiaParams = {
        fields:
          "id,name,mobile,email,business_type,contact_type,company_representative_name,company_representative_mobile",
        // search_fields: "name,mobile",
      };

      this.get("/contacts", getApiaParams).then((response) => {
        this.contacts = response.data.data.items;
        this.isContactLoading = false;
      });
    },

    reportFilters: {
      handler: function (val, oldVal) {
        this.updateSearchFilterData();
      },
      deep: true,
    },
  },
};
</script>